import { render, staticRenderFns } from "./SetCutSpinner.vue?vue&type=template&id=656345c4"
import script from "./SetCutSpinner.vue?vue&type=script&lang=js"
export * from "./SetCutSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports